// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a3fdd35c","453":"a0751e62","455":"e2ff7e07","977":"9faac07a"}[chunkId] + ".chunk.js";
};